import { cn } from "@/lib/utils";
import { IconStar } from "@/components/icons/Icons";
import { formatRating } from "@/lib/format";

export function Rating({ value, className, size = 13 }) {
  if (value === null || value === undefined) return null;
  return (
    <span className={cn("inline-flex items-center gap-1 font-semibold text-white", className)} data-testid="rating">
      <IconStar size={size} className="text-pk-star" />
      {formatRating(value)}
    </span>
  );
}

export function QualityBadge({ children, className }) {
  return (
    <span className={cn("inline-flex h-[22px] items-center rounded-[7px] border border-white/20 bg-white/[.06] px-1.5 text-[11px] font-bold tracking-[0.02em] text-white/90", className)} data-testid="quality-badge">
      {children}
    </span>
  );
}

export const Dot = () => <span className="text-white/30" aria-hidden="true">·</span>;
